import React from 'react';
import { Label, Card, CardBody, CardTitle, CardSubtitle, Form } from 'reactstrap';
import ContentLoader from "react-content-loader";
import moment from 'moment';
import 'moment/locale/hu';
import { t } from 'ttag';
import SvgViewer from '../../../commons/SvgViewer';
import StepperSection from './StepperSection';
import SuccessEmptyState from '../../../commons/SuccessEmptyState';
import EmptyState from '../../../commons/EmptyState';
import PaymentItem from '../../../components/Jegyezz/PaymentItem';
import Services from './Services';
import RendelesPortal from '../../../components/Jegyezz/RendelesPortal';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import TimeFormatter from '../../../commons/TimeFormatter';

export default class JegyvasarlasContent extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      // [1,2,3,4]
      bucket: [],
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      pageStatus: 'LOAD',
      // ['CANCELED', 'SUCCEEDED']
      redirectStatus: ['SUCCEEDED'],
      currentStep: 1,
      buttonLoading: false,
      activeSectors: [],
      formNev: '',
      formEmail: '',
      formRot: '',
      formMegvasarlas: false,
      formFoglalas: false,
      formCurrentPayment: null,
      formBarion: false,
      redirectUrl: "http://192.168.2.179:8288/jegy/event/38c502a56828c5a3fa05be070f1637e2",
      isControlActive: false,
      event: {
        eru: '',
        ecu: '',
        cid: undefined,
        des: undefined,
        eid: undefined,
        end: undefined,
        lid: undefined,
        nam: undefined,
        res: undefined,
        sta: undefined,
        otl: undefined,
      },
      layout: {
        areas: [],
        blocks: [],
        cod: undefined,
        hid: undefined,
        hna: undefined,
        lid: undefined,
        nam: undefined,
        str: {},
        texts: [],
        vad: undefined,
        vna: undefined
      },
      init: {
        sectors: [],
        now: '',
        rot: [],
        pty: []
      },
      tickets: [],
      rendeles: {
        gatewayUrl: '',
        rendeles: {},
        rendelesadat: {
          jegyadatok: []
        }
      }
    };
  }

  componentDidMount() {
    this.loadData();

    window.addEventListener("keydown", this.onKeyDown, false);
    window.addEventListener("keyup", this.onKeyUp, false);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown, false);
    window.removeEventListener("keyup", this.onKeyUp, false);
  }

  loadData = () => {
    const {
      match,
      id
    } = this.props;

    this.setState({
      pageStatus: 'LOAD',
    }, () => {
      Services.getAdminEvent(id, (err, res) => {
        if (!err) {
          this.setState({
            tickets: res[0].tickets,
            event: res[0].event,
            layout: res[0].layout,
            init: res[0].init,
            pageStatus: 'DATA'
          });
        }
      });
    }
    )
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    switch(name) {
      case "formMegvasarlas":
        this.setState({
          formFoglalas: false,
          formBarion: false,
          formNev: '',
          formEmail: '',
          [name]: value
        });
        break;
      case "formFoglalas":
        this.setState({
          formMegvasarlas: false,
          formBarion: false,
          formCurrentPayment: null,
          [name]: value
        });
        break;
      case "formBarion":
        this.setState({
          [name]: value
        });
        break;
      default:
        this.setState({
          [name]: value
        });
    }
  }

  handleRotChange = (e) => {
    const { target } = e;
    const value = target.value;
    const { name } = target;

    this.setState({
      formRot: name,
      formNev: '',
      formEmail: '',
      formCurrentPayment: null,
    });
  }

  getTicketTypeByTicketId = (ticketSector) => {
    let tickets = JSON.parse(JSON.stringify(this.state.tickets));
    let activeSectors = JSON.parse(JSON.stringify(this.state.activeSectors));
    let result = -1;
    // console.log(ticketSector);
    // console.log(tickets);
    // console.log(activeSectors);

    activeSectors.forEach((sector) => {
      tickets.forEach((ticket) => {
        if( (sector === ticket.tid) && (ticket.sec === ticketSector )) result = { sec: sector, pri: ticket.pri, nam: ticket.nam, cur: ticket.cur };
      })
    })

    return result
  }

  isTicketInBucket = (tid, deletedTickets) => {
    let hasTalalat = false;
    deletedTickets.forEach(element => {
      if(tid === element.tid) hasTalalat = true;
    });
    return hasTalalat
  }

  // onAreaClick = (clickedArea) => {
  //   console.log('----onAreaClick----');
  //   console.log(clickedArea);
  //   let activeTicket = getTicketTypeByTicketId(clickedArea.sec, clickedArea.tid);
  //   console.log(activeTicket);
    
  //   let isDelete = state.bucket.some( bucketItem => bucketItem.tid === activeTicket.sec);
  //   console.log(isDelete);

  //   if (isDelete) {
  //     setState({
  //       ...state,
  //       bucket: state.bucket.filter(bucketItem => bucketItem.tid !== activeTicket.sec),
  //       layout: layout
  //     });
  //   } else {
  //     if (activeTicket === -1) {
  //       props.globals.addError(clickedArea.lab + ' kiválasztása előtt jegytípus választása kötelező!')
  //     } else {
  //       setState({
  //         ...state,
  //         bucket: [...state.bucket,
  //         {
  //           aid: clickedArea.tid,
  //           lab: clickedArea.lab,
  //           tid: activeTicket.sec,
  //           pri: activeTicket.pri,
  //           nam: activeTicket.nam,
  //           cur: activeTicket.cur,
  //           qua: 1,
  //         }
  //         ],
  //         layout: layout
  //       });
  //     }
  //   }
  // }

  onSeatClick = (ticket, hasGroup, rowLabel) => {
    // console.log('Control: ', this.state.isControlActive);
    let isDelete = false;
    let blockIdx = 0;
    let layout = JSON.parse(JSON.stringify(this.state.layout));
    layout.blocks.forEach((block, idx) => {
      block.seats.forEach(seat => {
        if(seat.tid === ticket.tid) {
          if(seat.new) isDelete = true;
          blockIdx = idx;
          seat.new = !seat.new;
        }
      });
    });

    if(hasGroup || this.state.isControlActive) {
      layout.blocks[blockIdx].seats.forEach(element => {
        if(isDelete) {
          element.new = false
        } else {
          element.new = true
        }
      });
    }

    if(isDelete) {
      if(hasGroup || this.state.isControlActive) {
        let deletedTickets = [];
        layout.blocks.forEach(block => {
          block.seats.forEach(seat => {
            if(seat.tid === ticket.tid) {
              deletedTickets = block.seats;
            }
          });
        });
        let bucket = JSON.parse(JSON.stringify(this.state.bucket));
        let filteredBucket = bucket.filter((item, index) => {
          return !this.isTicketInBucket(item.sid, deletedTickets)
        })
        this.setState(prevState => ({
          bucket: filteredBucket,
          layout: layout
        }));
      } else {
        this.setState(prevState => ({
          bucket: prevState.bucket.filter(bucketItem => bucketItem.sid !== ticket.tid),
          layout: layout
        }));
      }
    } else {
      if(this.getTicketTypeByTicketId(ticket.sec) === -1 ) {
        this.props.globals.addError('Ülőhely választáshoz jegytípus választása kötelező!')
      } else {
        if(hasGroup || this.state.isControlActive) {
          let newTickets = [];
          layout.blocks.forEach(block => {
            block.seats.forEach(seat => {
              if(seat.tid === ticket.tid) {
                newTickets = block.seats.filter(s => !this.state.bucket.map(b => b.sid).includes(s.tid));
              }
            });
          });
          let newDetailedTickets = [];
          newTickets.forEach((item) => {
            if(!item.res) {
              newDetailedTickets.push({
                rowLabel: rowLabel,
                lab: item.lab,
                sid: item.tid,
                tid: this.getTicketTypeByTicketId(item.sec).sec,
                pri: this.getTicketTypeByTicketId(item.sec).pri,
                nam: this.getTicketTypeByTicketId(item.sec).nam,
                cur: this.getTicketTypeByTicketId(item.sec).cur,
              })
            }
          })
          // console.log(newDetailedTickets)
          this.setState(prevState => ({
            bucket: prevState.bucket.concat(newDetailedTickets),
            layout: layout
          }));
        } else {
          this.setState(prevState => ({
            bucket: [...prevState.bucket,
              {
                rowLabel: rowLabel,
                lab: ticket.lab,
                sid: ticket.tid,
                tid: this.getTicketTypeByTicketId(ticket.sec).sec,
                pri: this.getTicketTypeByTicketId(ticket.sec).pri,
                nam: this.getTicketTypeByTicketId(ticket.sec).nam,
                cur: this.getTicketTypeByTicketId(ticket.sec).cur,
              }
            ],
            layout: layout
          }));
        }
      }
    }
  }

  renderEventError = () => {
    return (
      <div className="row" style={{ padding: 20 }}>
        <div className="wrapper col-md-8" style={{ padding: 20 }}>
          <p style={{ fontSize: '1.75rem', textAlign: 'center' }}>{t`Ez az esemény nem található!`}</p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Rövidesen át lesz irányítva a főoldalra, vagy `}<a href={this.props.globals.public_url}>{t`kattintson ide`}</a> {t`az azonnali navigáláshoz.`}</p>
          <p style={{ fontSize: '1.1rem', textAlign: 'center' }}>{t`Elnézést kérünk a kellemetlenségért!`}</p>
        </div>
      </div>
    );
  }

  renderSectors = () => {
    const {
      init,
     } = this.state;

    const sectors = init.sectors.map((item, idx) => {
      return item.use && (
        <React.Fragment key={item.id}>
          <div className="col-md-12" style={{ padding: 0}}>
            <p style={{
              borderLeft: '8px solid #' + item.col,
              padding: 4, 
              paddingLeft: 10,
              margin: 0
            }}>{item.nam + ' (szabad/összes - ' + item.caf + '/' + item.cap + '): '}</p>
          </div>
          {this.renderTicketsByIDd(item.id, item.col, item.han, idx)}
        </React.Fragment>
      );
    });

    return sectors;
  }

  renderTicketsByIDd = (sectorId, sectorColor, isAccessible, sectorIdx) => {
    const {
      tickets,
      activeSectors
     } = this.state;

     const ticket = tickets.map((item, idx) => {
        if(item.sec === sectorId) {
          // console.log('LOG: ',  !activeSectors.includes(item.tid))
          if (!activeSectors.includes(item.tid)) {
            let newActiveSectors = JSON.parse(JSON.stringify(activeSectors));
            newActiveSectors[sectorIdx] = item.tid;
            this._clonedSectors = activeSectors;
          }
          return (
            <div className="col-md-4" key={item.tid}>
              <Card
                style={{
                  padding: 0 ,
                  marginTop: 10,
                  marginBottom: 10,
                  backgroundColor: activeSectors.includes(item.tid) ? '#' + sectorColor : '#fff',
                  color: activeSectors.includes(item.tid) ? '#fff' : '#212529',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  let newActiveSectors = JSON.parse(JSON.stringify(activeSectors));
                  newActiveSectors[sectorIdx] = item.tid;
                  this.setState({
                    activeSectors: newActiveSectors
                  })
                }}
              >
                <CardBody>
                  <CardTitle>
                    {item.nam + ' '}
                    {isAccessible &&  <i className="fa fa-wheelchair" aria-hidden="true" />}
                  </CardTitle>
                  <CardSubtitle>{item.pri + ' ' + item.cur}</CardSubtitle>
                </CardBody>
              </Card>
            </div>
          )
        }
     });

     return ticket;
  }

  isFoglalasOrVasarlas = () => {
    if (!this.state.formRot || this.state.formRot === '') return null;
    return this.state.formRot;
  }

  isEmptyOrNull = (data) => {
    if(!data  || data === '') return true;
    return false;
  }

  getPaymenType = () => {
   return this.state.formCurrentPayment && this.state.formCurrentPayment.name;
  }

  getPurchaseObj = () => {
    return {
      ste: this.state.currentStep,
      now: this.state.init.now,
      eid: this.state.event.eid,
      rid: this.state.event.rid,
      nam: this.state.formNev,
      ema: this.state.formEmail,
      seattickets: this.state.bucket,
      rot: this.isFoglalasOrVasarlas(),
      pty: this.getPaymenType(),
    }
  }

  onPaymentClick = (item) => {
    this.setState({
      formCurrentPayment: item
    })
  }

  isActivePayment = (name) => {
    if(this.state.formCurrentPayment) {
      if(name === this.state.formCurrentPayment.name) return true;
      return false;
    }
    return false;
  }

  renderPaymentCards = () => {
    return this.state.init.pty.map((item) => {
      return <PaymentItem title={item.caption} subtitle={item.caption} active={this.isActivePayment(item.name)} onClick={this.onPaymentClick} item={item} key={item.name} />
    })
  }

  onKeyDown = (e) => {
    if (e.key === 'Control') {
      this.setState({
        isControlActive: true
      })
    }
  }

  onKeyUp = (e) => {
    if (e.key === 'Control') {
      this.setState({
        isControlActive: false
      })
    }
  }

  render() {
    const {
      match
    } = this.props;

    const {
      activeSectors,
      currentStep,
      formMegvasarlas,
      formFoglalas,
      formBarion,
      formRot,
      bucket,
      event,
      layout,
      init,
      redirectStatus
     } = this.state;

    return (
      <React.Fragment>
        {false && (
          <RendelesPortal>
            <SvgViewer
              onKeyDown={this.onKeyDown}
              onKeyUp={this.onKeyUp}
              data={layout}
              szektorok={init.sectors}
              szinek={{
                coa: init.coa,
                con: init.con,
                cop: init.cop
              }}
              onSeatClick={() => {}}
              onAreaClick={() => {}}
            />
          </RendelesPortal>
        )}
        <iframe name="pdf-area-jegyvasarlas" id="pdf-area-jegyvasarlas" src={this.state.fileURL} style={{ visibility: 'hidden', height: 0, width: 0 }} />
        {this.state.pageStatus === 'NETW' ? this.renderEventError() : (
          <div className="landing__section">
            <div className="container">
              <div className="expanded__inner" style={{}}>
                <h2 className="expanded__title subtitle">{t`JEGYVÁSÁRLÁS`}</h2>
              </div>
              <div className="container" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div className="row justify-content-md-center">
                  <div className="col-md-3 d-none d-md-block">
                    {{
                      LOAD: (
                        <ContentLoader
                          height={500}
                          width={900}
                          speed={1}
                          primaryColor="#f3f3f3"
                          secondaryColor="#ecebeb"
                        >
                          <rect x="20" y="15" rx="20" ry="20" width="300" height="450" />
                        </ContentLoader>
                      ),
                      DATA: (
                        (!this.isEmptyOrNull(this.state.event.ecu) && !this.isEmptyOrNull(this.state.event.eru)) && (
                          <img
                            src={this.state.event.eru + this.state.event.ecu}
                            alt="poster"
                            className="img-fluid"
                            style={{ width: '100%' }}
                          />
                        )
                      ),
                      NETW: (<span />),
                    }[this.state.pageStatus]}
                  </div>
                  <div className="col-md-9">
                    {{
                      LOAD: (
                        <ContentLoader
                          height={500}
                          width={1300}
                          speed={1}
                          primaryColor="#f3f3f3"
                          secondaryColor="#ecebeb"
                        >
                          <rect x="20" y="17" rx="10" ry="10" width="840" height="66" />
                          <rect x="20" y="150" rx="10" ry="10" width="500" height="50" />
                          <rect x="20" y="250" rx="10" ry="10" width="500" height="50" />
                          <rect x="20" y="350" rx="10" ry="10" width="500" height="50" />
                        </ContentLoader>
                      ),
                      DATA: (
                        <React.Fragment>
                          <h3 style={{ marginBottom: 18 }}>{/*match.params.eventId*/}{event.nam}</h3>
                          <p><b>{t`Helyszín`} </b> {layout.vna}{' '}{layout.vad}</p>
                          <p><b>{t`Időpont:`} </b> {event.sta && TimeFormatter.formatLLLL(event.sta)} </p>
                          <p><b>{t`Leírás:`} </b> {event.des} </p>
                        </React.Fragment>
                      ),
                      NETW: (<span />),
                    }[this.state.pageStatus]}
                  </div>
                </div>
              </div>
            </div>
            <div className="landing__section" style={{ marginTop: 0 }}>
              <div className="container">
                <div>
                  <StepperSection currentStep={currentStep} >
                    {{
                      1: (
                        <React.Fragment>
                          <div className="wrapper tickettype" style={{ padding: 20 }} >
                            <p className="tickettype-card-title">{t`Jegytípus választása:`}</p>
                            <p>{t`Jegyvásárláshoz, illetve foglaláshoz kérjük, először válassza ki a jegy típusát!`}</p>
                            <div className="row justify-content-center" style={{ margin: 0 }}>
                              {this.renderSectors()}
                            </div>
                          </div>
                          <SvgViewer
                            onKeyDown={this.onKeyDown}
                            onKeyUp={this.onKeyUp}
                            data={layout}
                            szektorok={init.sectors}
                            szinek={{
                              coa: init.coa,
                              con: init.con,
                              cop: init.cop
                            }}
                            onSeatClick={this.onSeatClick}
                            onAreaClick={this.onAreaClick}
                          />
                          <div className="wrapper" style={{ padding: 20 }}>
                            <p style={{ fontSize: '1.65rem' }}>{t`Választott jegyek:`}</p>
                            <div className="row">
                              {bucket.length > 0 ? bucket.map((item, index) => {
                                let cop = this.state.event.cop ? this.state.event.cop + '%' : null;
                                let cof = this.state.event.cof ? this.state.event.cof + ' ' + item.cur : null;

                                return (
                                  <div className="col-md-12">
                                    <div style={{ padding: 15, border: '1px solid #e4e4e4', marginBottom: 6 }}>
                                      {/*<b>{t`Szektor:`}</b><span>{' ' + 'TODO' + ', '}</span> */}
                                      <b>{t`Sor:`}</b><span>{' ' + item.rowLabel + ', '}</span>
                                      <b>{t`Szék:`}</b><span>{' ' + item.lab + ', '}</span>
                                      <b>{t`Jegytípus:`}</b><span>{' ' + item.nam + ', '}</span>
                                      <b>{t`Jegyár:`}</b><span>{' ' + item.pri + ' ' + item.cur + ' *, '}</span>
                                      {/* <b>{t`Kényelmi díj:`}</b><span>{' ' + (this.state.event.cop ? this.state.event.cop + ' % + ' : '') + (this.state.event.cof ? this.state.event.cof + ' Ft ' : '')}</span> */}
                                      <b>{t`Kényelmi díj:`}</b><span> {cop ? cop + (cof ? ' + ' + cof : '') : (cof ? cof : '') + ' '}</span>
                                    </div>
                                  </div>
                                )
                              }) : <EmptyState hasImage />}
                            </div>
                            { bucket.length > 0 && (
                              <div className="row">
                                {t`* A jegyár a kényelmi díjat már tartalmazza!`}
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                        ),
                      2: (
                        <div className="wrapper" style={{ padding: 20 }}>
                          <p style={{ fontSize: '1.65rem' }}>{t`Rendelés típusa:`}</p>
                          <Form id='my-form'>
                            <div className="row justify-content-center" style={{ margin: 0 }}>
                            {this.state.init.rot.map((item) => {
                              return (
                                <div className="col-md-6">
                                <div 
                                  style={{
                                    border: '1px solid #bbbaba', 
                                    marginTop: 6,
                                    marginBottom: 6,
                                    padding: 10
                                  }}
                                >
                                  <RFField
                                    key={item.name}
                                    name={item.name}
                                    type="radio"
                                    id={item.name}
                                    checked={formRot === item.name}
                                    onChange={this.handleRotChange}
                                  />
                                  <label htmlFor={item.name}>{item.publiccaption}</label>
                                  <br />
                                  {item.description}
                                  <br />
                                </div>
                              </div>
                              )
                            })}
                            </div>
                          </Form>
                          {formRot === 'HELYSZINI_FOGLALAS' && (
                            <React.Fragment>
                              <p style={{ fontSize: '1.65rem' }}>Személyes adatok megadása:</p>
                              <Form id='my-form'>
                                  <RFField label={t`Név: *`} name="formNev" id="formNev" autoComplete="off" value={this.state.formNev} onChange={this.handleInputChange} required />
                                  <RFField label={'E-mail: *'} name="formEmail" id="formEmail" autoComplete="off" value={this.state.formEmail} onChange={this.handleInputChange} required />
                              </Form>
                              <p>* = {t`A mezők kitöltése kötelező`}</p>
                            </React.Fragment>
                          )}
                          {formRot === 'HELYSZINI_VASARLAS' && (
                            <React.Fragment>
                              <p style={{ fontSize: '1.65rem' }}>{t`Fizetési mód megadása:`}</p>
                              <div className="row">
                                {this.renderPaymentCards()}
                              </div>
                            </React.Fragment>
                          )}
                        </div>
                      ),
                      3: (
                        <div className="wrapper" style={{ padding: 20 }}>
                          <p style={{ fontSize: '1.65rem' }}>{t`Áttekintés és véglegesítés:`}</p>
                          <p style={{ fontSize: '1.4rem' }}>{t`Rendelés adatai:`}</p>
                          <div className="container">
                            <p><strong>{'Rendelő neve: '}</strong>{this.state.rendeles.rendelesadat.rendeloNev}</p>
                            <p><strong>{'Rendelő e-mail címe: '}</strong>{this.state.rendeles.rendelesadat.rendeloEmail}</p>
                            <div className="row">
                                <div id="no-more-tables" style={{ width: '100%' }}>
                                    <table className="col-sm-12 table-reservation table-striped table-condensed cf">
                                    <thead className="cf">
                                      <tr>
                                        <th>{t`Jegytípus`}</th>
                                        <th>{t`Ár`}</th>
                                        <th>{t`Kényelmi díj`}</th>
                                        <th>{t`Hely`}</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.rendeles.rendelesadat.jegyadatok.map((item) => {
                                          return (
                                            <tr key={item.helyId}>
                                              <td data-title={t`Jegytípus`}>{item.jegyTipus}</td>
                                              <td data-title={t`Ár`}>{item.jegyArS}</td>
                                              <td data-title={t`Kényelmi díj`}>{this.state.rendeles.rendelesadat.esemenyKenyelmiDijS}</td>
                                              <td data-title={t`Hely`}>{item.jegyHely}</td>
                                              {/* <td data-title="Hely">{item.jegySzektor + ' ' + item.jegySor + '. sor, ' + item.jegySzek + '. szék'}</td> */}
                                            </tr>
                                          )
                                        })
                                      }
                                    </tbody>
                                  </table>
                                </div>
                            </div>
                            <p style={{ fontSize: 18 }}>{t`Összesen fizetendő: `}<strong>{this.state.rendeles.rendelesadat.rendelesOsszegS}</strong></p>
                        </div>
                      </div>
                      ),
                      4: (
                        <div className="wrapper" style={{ padding: 20 }}>
                          <p style={{ fontSize: '1.65rem' }}>{t`Sikeres foglalás!`}</p>
                          {{
                            CANCELED: (
                              <SuccessEmptyState title="Sikertelen vásárlás" subtitle=":(" />
                            ),
                            SUCCEEDED: (
                              <div className="empty-state animated fadeIn">
                                <img
                                  src={process.env.PUBLIC_URL + '/img/mail-sent.svg'}
                                  className="img-fluid"
                                  alt="img-avatar"
                                />
                                <h3>{'Sikeres megrendelés!'}</h3>
                                <p>{'Az emailt elküldtük az Ön által megadott címre.'}</p>
                            </div>
                            ),
                          }[this.state.redirectStatus]}
                        </div>
                      )
                    }[currentStep]}
                  </StepperSection>
                </div>
              </div>
            </div>
            <div className="container" >
              <div className="row" style={{ margin: 0 }}>
                <div className="col-md-12" style={{ padding: 0, marginBottom: 16 }}>
                {/* currentStep > 1 && currentStep !== 5 && 
                    <button
                      onClick={() => {
                        this.setState(prevState => ({
                          currentStep: prevState.currentStep - 1
                        }));
                      }}
                      type="button"
                      className="search-button-style btn btn-secondary"
                    >
                      {t`Vissza`}
                    </button>
                    */}
                  {(currentStep < 3 || (currentStep === 3 && ( formRot !== 'HELYSZINI_FOGLALAS'))) && 
                    <button
                      type="button"
                      className="search-button-style btn btn-secondary float-right"
                      disabled={this.state.buttonLoading}
                      onClick={() => {
                        switch (this.state.currentStep) {
                          case 1:
                            this.setState({ buttonLoading: true });
                            Services.sendAdminPurchase(this.getPurchaseObj(), false, (err, res) => {
                              if (!err) {
                                let event = JSON.parse(JSON.stringify(this.state.event))
                                event.rid = res[0].rendeles.rid;
                                this.setState({
                                  event: event,
                                  buttonLoading: false,
                                  currentStep: 2
                                });
                              } else {
                                this.setState({ buttonLoading: false });
                              }
                            });
                            break;
                          case 2:
                            this.setState({ buttonLoading: true });
                            Services.sendAdminPurchase(this.getPurchaseObj(), false, (err, res) => {
                              if (!err) {
                                this.setState({
                                  rendeles: res[0],
                                  buttonLoading: false,
                                  currentStep: 3
                                });
                              } else {
                                this.setState({ buttonLoading: false });
                              }
                            });
                            break;

                            case 3:
                              this.setState({ buttonLoading: true });
                              Services.getRendelesPrint(this.state.event.rid, (err, res) => {
                                if (!err) {
                                  let fileURL = URL.createObjectURL(new Blob([res[0]], { type: 'application/pdf' }));
                                  this.setState({
                                    fileURL 
                                  }, () => {
                                    window.setTimeout(() => {
                                      window.frames["pdf-area-jegyvasarlas"].focus();
                                      window.frames["pdf-area-jegyvasarlas"].print();
                                      window.setTimeout(() => {
                                      window.close();
                                      }, 50);
                                    }, 1000);
                                  })
                                  this.props.globals.addSuccess('Jegy nyomtatás!');
                                  this.setState({
                                    buttonLoading: false,
                                  });
                                } else {
                                  this.setState({ buttonLoading: false });
                                }
                              });
                              // Services.sendAdminPurchase(this.getPurchaseObj(), (err, res) => {
                              //   if (!err) {
                              //     if(this.state.formMegvasarlas && this.state.formBarion) {

                              //     }
                              //     this.setState({
                              //       rendeles: res[0],
                              //       buttonLoading: false,
                              //       currentStep: 4
                              //     });
                              //   } else {
                              //     this.setState({ buttonLoading: false });
                              //   }
                              // });
                              break;
                            case 4:
                              this.setState({ buttonLoading: true });
                              Services.sendAdminPurchase(this.getPurchaseObj(), false, (err, res) => {
                                if (!err) {
                                  if(this.state.formMegvasarlas && this.state.formBarion) {
                                    window.location.replace(this.state.rendeles.gatewayUrl);
                                  } else {
                                    this.setState({
                                      buttonLoading: false,
                                      currentStep: 5
                                    });
                                  }
                                } else {
                                  this.setState({ buttonLoading: false });
                                }
                              });
                              break;
                        
                          default:
                            break;
                        }
                        // this.setState(prevState => ({
                        //   currentStep: prevState.currentStep + 1
                        // }), () => {
                        //   if(this.state.currentStep === 4) {
                        //     Services.paymentStart(this.state.redirectUrl, '', (err, res) => {
                        //       if (!err) {
                        //         window.location.replace(res[0].GatewayUrl)
                        //         // window.open(res[0].GatewayUrl,"_self")
                        //       } else {
                        //       }
                        //     });
                        //   }
                        // });
                      }}
                    >
                      {this.state.currentStep === 3 ? ( this.state.formRot === 'HELYSZINI_FOGLALAS' ?  t`Lefoglalás ` : t`Nyomtatás ` ) : t`Tovább `}
                      { this.state.buttonLoading && (
                        <div className="spinner-border spinner-border-sm" role="status" style={{ marginBottom: 2 }}>
                          <span className="sr-only">Loading...</span>
                        </div>
                      )}
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}